import { render, staticRenderFns } from "./SignatureDNIeEditor.vue?vue&type=template&id=b48dc452&scoped=true"
import script from "./SignatureDNIeEditor.vue?vue&type=script&lang=js"
export * from "./SignatureDNIeEditor.vue?vue&type=script&lang=js"
import style0 from "./SignatureDNIeEditor.vue?vue&type=style&index=0&id=b48dc452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48dc452",
  null
  
)

export default component.exports